import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'wheat',
      d: 'M-2.5,-6.5h1.5v0.5h-1.5zM-0.5,-2h2v0.5h-2zM-0.5,-1.5h1v0.5h-1zM1,-1.5h0.5v0.5h-0.5zM-0.5,-1h2v0.5h-2zM-1,-0.5h1v0.5h-1zM0.5,-0.5h0.5v0.5h-0.5zM-1,0h0.5v0.5h-0.5zM0.5,0h1v0.5h-1z',
    },
    {
      paint: 'heron',
      d: 'M-0.5,-7.5h1v0.5h-1zM-1,-7h2v0.5h-2zM0,-6.5h1v0.5h-1zM-0.5,-6h1v0.5h-1zM-0.5,-5.5h1.5v0.5h-1.5zM0.5,-5h0.5v0.5h-0.5zM-0.5,-4.5h1.5v0.5h-1.5zM-1,-4h2.5v1h-2.5zM-0.5,-3h2v1h-2z',
    },
    { paint: 'seagull', d: 'M-1,-6.5h1v0.5h-1zM-1,-6h0.5v0.5h-0.5zM0,-5h0.5v0.5h-0.5z' },
  ],
  pixels: 59,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
